// validation.ts
type ComparisonOperator = '>' | '<' | '==' | '>=' | '<=' | '!=';
type ValidationType = 'percentage' | 'amount' | 'count' | 'age';
type QualifierType =
  | 'isBeneficialOwner'
  | 'isShareholder'
  | 'isDirector';

export type ValidationRule = {
  qualifier: QualifierType;
  operator: ComparisonOperator;
  validationType: ValidationType;
  threshold: number;
  errorMessage: string;
};

type ValidationResult = {
  isValid: boolean;
  errors: string[];
  adjustedValue?: number;
};

const validateSingleRule = (value: number, rule: ValidationRule): boolean => {
  switch (rule.operator) {
    case '>':
      return value > rule.threshold;
    case '<':
      return value < rule.threshold;
    case '==':
      return value === rule.threshold;
    case '>=':
      return value >= rule.threshold;
    case '<=':
      return value <= rule.threshold;
    case '!=':
      return value !== rule.threshold;
    default:
      return false;
  }
};

export const validateRules = (
  value: number,
  rules: ValidationRule[]
): ValidationResult => {
  const result: ValidationResult = {
    isValid: true,
    errors: [],
    adjustedValue: value,
  };

  for (const rule of rules) {
    const isValid = validateSingleRule(value, rule);
    if (!isValid) {
      result.isValid = false;
      result.errors.push(rule.errorMessage);

      if (rule.operator === '>=' || rule.operator === '>') {
        result.adjustedValue = Math.max(rule.threshold, result.adjustedValue!);
      } else if (rule.operator === '<=' || rule.operator === '<') {
        result.adjustedValue = Math.min(rule.threshold, result.adjustedValue!);
      }
    }
  }

  return result;
};
